var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Industry Expertise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.91 13.843h9.096V26l-4.55-3.84L3.91 26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4F4D4C",
    strokeWidth: 2,
    fill: "#FFF",
    d: "M5 5h54v38H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.114 15H49.7M14.114 19H49.7M22.114 23h19.73",
    stroke: "#4F4D4C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 34)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4F4C4D",
    strokeWidth: 2,
    d: "M4.91 14.843v9.004l3.547-2.995 3.55 2.995v-9.004H4.908z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FC0",
    cx: 8.5,
    cy: 8.5,
    r: 7.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMock);
export default __webpack_public_path__ + "static/media/mock.11b7f0a3.svg";
export { ForwardRef as ReactComponent };